import { useGetUser } from 'atom/user';
import { END_ANIMATION_PROPERTY, START_ANIMATION_PROPERTY, VIEWPORT_PROPERTY } from 'components/constants/animation-properties';
import { countryCodeToEmoji, pointCountry } from 'components/function';
import { motion } from 'framer-motion'
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ISpecialData } from 'types/special';
import { ReactComponent as ArrowRight } from 'assets/special/rigthArrow.svg'
import { ReactComponent as Cal } from 'assets/special/cal.svg'
import { useEffect, useState } from 'react';

interface ICard {
    item: ISpecialData
    idx: number,
}

const Card = ({ item, idx }: ICard) => {
    const navigate = useNavigate();
    const user = useGetUser();
    const [remaining, setRemaining] = useState<string>('');
    const [isBlink, setIsBlink] = useState<boolean>(false);
    const [isWithinMonth, setIsWithinMonth] = useState<boolean>(false);

    useEffect(() => {
        const targetTime = new Date(item.validTo).getTime();
        const now = Date.now();
        const diffDays = (targetTime - now) / (1000 * 60 * 60 * 24);
        const withinMonth = diffDays <= 30;

        setIsWithinMonth(withinMonth);

        if (!withinMonth) return;

        // 1초마다 남은 시간 계산
        const timer = setInterval(() => {
            const now = Date.now();
            const diff = targetTime - now;

            if (diff <= 0) {
                setRemaining('만료됨');
                clearInterval(timer);
                return;
            }

            const days = Math.floor(diff / (1000 * 60 * 60 * 24));
            const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
            const minutes = Math.floor((diff / (1000 * 60)) % 60);
            const seconds = Math.floor((diff / 1000) % 60);

            const str =
                days > 0
                    ? `${days}일 ${hours}시간 ${minutes}분 ${seconds}초 남음`
                    : `${hours}시간 ${minutes}분 ${seconds}초 남음`;

            setRemaining(str);
        }, 1000);

        // 깜빡임 효과
        const blinkTimer = setInterval(() => {
            setIsBlink((prev) => !prev);
        }, 500);

        return () => {
            clearInterval(timer);
            clearInterval(blinkTimer);
        };
    }, [item.validTo]);

    const goDetail = (id: number) => {
        if (user.id) {
            navigate(`/special/detail?id=${id}`)
        }
        else {
            toast.error('로그인 후 이용가능합니다.')
        }
    }



    const CountryInfo = ({ item, type }: { item: ISpecialData, type: number }) => {
        const info = {
            code: type === 0 ? item.originCode : item.destinationCode,
            address: type === 0 ? item.originAddress : item.destinationAddress,
        }

        return (
            <div className={`flex flex-col flex-1 ${type === 0 ? 'items-start' : 'items-end'}`}>
                <p className='text-42 leading-none flag'>{countryCodeToEmoji(info.code.slice(0, 2))}</p>
                <div className='font-semibold text-sm'>
                    <p className='leading-none'>{info.address}</p>
                    <p dangerouslySetInnerHTML={{ __html: pointCountry(info.code) }}></p>
                </div>
            </div>
        )
    }

    return (
        <motion.div
            initial={START_ANIMATION_PROPERTY}
            whileInView={END_ANIMATION_PROPERTY}
            viewport={VIEWPORT_PROPERTY}
            transition={{ delay: idx * 0.1 }}
            className='bg-white shadow-lg border-1 border-transparent hover:border-primary rounded-xl overflow-hidden transition-all cursor-pointer'
            onClick={() => {
                goDetail(item.id)
            }}
        >
            <div className='flex items-center gap-3 bg-primary px-3 py-4 w-full font-semibold'>
                {/* <div className='border border-white rounded-full w-6 h-6'></div> */}
                <div className="text-white truncate">
                    {item.carrierName}
                </div>
            </div>

            <div className='px-3'>
                <div className='flex justify-between items-center gap-4 py-3'>
                    <CountryInfo item={item} type={0} />
                    <ArrowRight className='self-center' />
                    <CountryInfo item={item} type={1} />
                </div>

                {
                    item.isVesselInfoVisible &&
                    <div className='flex justify-between items-center gap-9 pb-3 border-[#D9D9D9] border-b font-semibold text-[#9D9EB7] text-sm text-center'>
                        <div className='flex-1 bg-[#F8F8FA] py-1'>
                            ETD {item.etd}
                        </div>
                        <div className='flex-1 bg-[#F8F8FA] py-1'>
                            ETA {item.eta}
                        </div>
                    </div>
                }
                <div className='flex justify-end items-center gap-3 py-3 border-[#D9D9D9] border-b'>
                    <p className='bg-[#EEF4FF] px-1.5 rounded-full text-[#9D9EB7] text-lg'>{item.containerType}</p>
                    <p className='font-bold text-2xl'>{item.currency} {item.freightRate?.toLocaleString()}</p>
                </div>

                <div
                    className={`flex justify-center items-center gap-3 py-3 font-bold text-sm ${isWithinMonth && isBlink ? 'text-red' : 'text-[#9D9EB7]'
                        }`}
                >
                    <Cal fill={(isWithinMonth && isBlink) ? '#F04400' : '#9D9EB7'} />
                    {isWithinMonth ? (
                        <>
                            {item.validTo} 까지 {remaining && `(${remaining})`}
                        </>
                    ) : (
                        `${item.validTo} 까지`
                    )}
                </div>
            </div>
        </motion.div>
    )
}

export default Card